import { NgModule, Component, ViewChild, ViewChildren, OnInit, AfterViewInit, SecurityContext, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { Router, Route } from "@angular/router";
import { RouteURLConstants } from '../../../../constants/upplm.constants';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';


@Component({
    selector: 'qvcreated1',
    template: require('./qvdashboardCreated1.component.html'),
    styles: ['a{cursor:pointer} ']
})

export class QVCreated1Component {

    public ham: boolean = false;
    public paramsUrl: string = '?loc=en_US&placardid=';    

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    @Output() placardIdDetail = new EventEmitter<string>();

    constructor(private router: Router) { }

    ngOnInit() {
        /*empty*/
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }

    searchInformation() {
        // Call API for search Information
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.dataSearch.placardId));
    }
}